export const format = (v: number, digits: number = 2) =>
	v.toLocaleString(undefined, {
		minimumFractionDigits: digits,
		maximumFractionDigits: digits,
	})
